import { httpService } from "./httpService";

export const planService = {
    async getPlans(billing_period: string) {
        try {
            const response = await httpService.getRequest<any>(`billing/plans?billing_period=${billing_period}`);
            const plans = response;
            return plans;
        } catch (error) {
            console.error("Error fetching plans data:", error);
        }
    },
};